import PropTypes from 'prop-types';

import Icon from 'shopper/components/Icon';
import Text from 'shopper/components/Text';

const StatItem = ({ iconName, size, count }) => (
  <div className="mx-2 flex items-center">
    <Icon className="mr-1" name={iconName} size={size} />
    <Text size="size2">{count}</Text>
  </div>
);

StatItem.propTypes = {
  iconName: PropTypes.string.isRequired,
  size: PropTypes.string.isRequired,
  count: PropTypes.number.isRequired,
};

export default StatItem;
